import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Sparkles, X, ArrowRight } from "lucide-react";
import { persistentPreferences } from "@/utils/preferences";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NEW_STATES = new Set(["CA", "CO", "TN", "AZ", "WA", "MN", "MO", "IN"]);
const DISMISS_KEY = "iwmc_market_spotlight_v3";

export function NewMarketSpotlight() {
  const [markets, setMarkets] = useState([]);
  const [dismissed, setDismissed] = useState(() => persistentPreferences.get(DISMISS_KEY) === "1");

  useEffect(() => {
    if (dismissed) return;
    axios.get(`${API}/areas`).then((r) => {
      setMarkets((r.data || []).filter((a) => a.status === "active" && NEW_STATES.has(a.state)));
    }).catch(() => {});
  }, [dismissed]);

  if (dismissed || markets.length === 0) return null;
  const highlights = ["Los Angeles", "Seattle Metro", "Denver Metro", "Nashville Metro"].filter((n) => markets.some((m) => m.name === n));
  const names = highlights.length ? highlights : markets.slice(0, 3).map((m) => m.name);
  const extra = markets.length - names.length;

  return (
    <div className="bg-brand-red text-white" data-testid="new-market-spotlight">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3 flex-wrap">
        <span className="flex items-center gap-2 font-body text-sm font-bold whitespace-nowrap">
          <Sparkles className="w-4 h-4 flex-shrink-0" /> Just launched:
        </span>
        <span className="font-body text-sm text-white/90">
          {names.join(" · ")}{extra > 0 ? ` + ${extra} more markets` : ""}
        </span>
        <Link to="/areas"
          className="ml-auto flex items-center gap-1.5 font-mono text-[10px] font-bold uppercase bg-white/15 hover:bg-white/25 px-3.5 py-2 transition-colors whitespace-nowrap"
          data-testid="spotlight-explore-link">
          Explore New Areas <ArrowRight className="w-3 h-3" />
        </Link>
        <button onClick={() => { persistentPreferences.set(DISMISS_KEY, "1"); setDismissed(true); }}
          className="text-white/70 hover:text-white p-1.5 transition-colors" aria-label="Dismiss announcement"
          data-testid="spotlight-dismiss-btn">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
